// extracted by mini-css-extract-plugin
export default {"newsletter-wrap":"LPNewsletter_newsletter-wrap__whaK6","bg":"LPNewsletter_bg__G8T4v","content":"LPNewsletter_content__rVYEy","titleWrap":"LPNewsletter_titleWrap__UspMV"};